import DemoMonarchSpecRouteScreen from "../../../../src/features/arrangements/screens/DemoMonarchSpecRouteScreen";

export default function LegacyArrangementConfirmationRoute() {
  return <DemoMonarchSpecRouteScreen fixedPath="arrangements/confirmation" />;
}
